<template>
  <div class="prepare-exam__info">
    <div class="form-group">
      <label class="display-block secondary-color-txt font-sanpro-semibold">Tiêu đề <span class="color-err">*</span></label>
      <input
        type="text"
        class="form-h35 border-rd-20 color_bg_gray_light full-width border-0"
        v-model="examInfo.name"
        :class="{'form-item-err': isSubmit && !examInfo.name}"
      >
      <div v-if="isSubmit && !examInfo.name" class="invalid mt-2 color-err font-size-15">Vui lòng nhập tiêu đề</div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-xl-6">
          <div class="form-group__item">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-item">
                  <label class="display-block secondary-color-txt font-sanpro-semibold">Lớp <span class="color-err">*</span></label>
                  <div class="item item__class input-custom-icon select-custom">
                    <select
                      class="primary-color-txt border-rd-20 font-size-15 form-h35 color_bg_gray_light border-0 full-width"
                      v-model="examInfo.classId"
                      :class="{'form-item-err': isSubmit && !examInfo.classId}"
                    >
                      <option v-for="(item, index) of classesExam" :key="index" :value="item.classId">{{ item.name }}</option>
                    </select>
                    <i class="icon-arrow-down font-size-13 primary-color"></i>
                  </div>
                  <div v-if="isSubmit && !examInfo.classId" class="invalid mt-2 color-err font-size-15">Vui lòng chọn lớp</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-item">
                  <label class="display-block secondary-color-txt font-sanpro-semibold">Môn</label>
                  <div class="item item__class input-custom-icon select-custom">
                    <select
                      class="primary-color-txt border-rd-20 font-size-15 form-h35 color_bg_gray_light border-0 full-width"
                      v-model="examInfo.subjectId"
                    >
                      <option v-for="(item, index) of subjectsExam" :key="index" :value="item.subjectId">{{ item.name }}</option>
                    </select>
                    <i class="icon-arrow-down font-size-13 primary-color"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="form-group__item">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-item">
                  <label class="display-block secondary-color-txt font-sanpro-semibold">Đề thi/ Bài kiểm tra <span class="color-err">*</span></label>
                  <div class="item item__class input-custom-icon select-custom">
                    <select
                      class="primary-color-txt border-rd-20 font-size-15 form-h35 color_bg_gray_light border-0 full-width"
                      v-model="examInfo.timeToDo"
                      :class="{'form-item-err': isSubmit && !examInfo.timeToDo}"
                    >
                      <option v-for="(item, index) of examTimesToDo" :key="index" :value="item.value">{{ item.name }}</option>
                    </select>
                    <i class="icon-arrow-down font-size-13 primary-color"></i>
                  </div>
                  <div v-if="isSubmit && !examInfo.timeToDo" class="invalid mt-2 color-err font-size-15">Vui lòng chọn Đề thi/ Bài kiểm tra</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-item">
                  <label class="display-block secondary-color-txt font-sanpro-semibold">Mã đề</label>
                  <input
                    type="text"
                    class="form-h35 border-rd-20 color_bg_gray_light full-width border-0"
                    v-model="examInfo.code"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <div class="form-item">
            <label class="display-block secondary-color-txt font-sanpro-semibold">Trường</label>
            <input
              type="text"
              class="form-h35 border-rd-20 color_bg_gray_light full-width border-0"
              v-model="examInfo.schoolName"
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-item">
            <label class="display-block secondary-color-txt font-sanpro-semibold">Tên giáo viên</label>
            <input
              type="text"
              class="form-h35 border-rd-20 color_bg_gray_light full-width border-0"
              v-model="examInfo.teacherName"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="display-block secondary-color-txt font-sanpro-semibold">Chú thích</label>
      <input
        type="text"
        class="form-h35 border-rd-20 color_bg_gray_light full-width border-0"
        v-model="examInfo.note"
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { apiGetListClassOfTeacher, apiGetListSubjectOfTeacher } from './../../_api/exam'
import { STORE_KEY } from './../../_store/constants'
import { getAuth } from "@/utils/jwt"

export default {
  name: 'ExamInfo',
  props: {
    isSubmit: Boolean
  },
  data () {
    return {
      classId: 0,
      subjectId: 0
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo', 'classesExam', 'subjectsExam', 'paramsGetQuestionsSample', 'examTimesToDo']),
    authInfo () {
      return getAuth()
    }
  },
  watch: {
    'examInfo.classId': 'getSubjectByClassId'
  },
  created () {
    this.getListClassOfTeacher()
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetExamPrepareInfo', 'acSetClassesExam', 'acSetSubjectsExam', 'acSetParamsGetQuestionsData']),

    async getListClassOfTeacher () {
      let classes = await apiGetListClassOfTeacher().then(res=> res.data)
      if (!classes || classes.length === 0) {
        return;
      }
      await this.acSetClassesExam(classes)
      this.acSetExamPrepareInfo({...this.examInfo, classId: classes[0].classId})
      this.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: classes[0].classId})
      this.getSubjectByClassId()
    },

    async getSubjectByClassId () {
      let indexClassCurr = this.classesExam.findIndex(cl => cl.classId === this.examInfo.classId)
      if (indexClassCurr === -1) {
        return;
      }
      let subjects = []
      if (!this.classesExam[indexClassCurr].subjects) {
        subjects = await apiGetListSubjectOfTeacher({classId: this.examInfo.classId}).then(res => res.data)
        if (!subjects || subjects.length === 0) {
          return;
        }
      } else {
        subjects = this.classesExam[indexClassCurr].subjects
      }
      this.acSetSubjectsExam(subjects)
      this.subjectId = subjects[0].subjectId
    }
  }
}
</script>

<style>
</style>
